// extracted by mini-css-extract-plugin
export var label = "_dv-5";
export var slideContainer = "_dv-0";
export var slider = "_dv-1";
export var sliderLg = "_dv-4";
export var sliderMd = "_dv-3";
export var sliderSm = "_dv-2";